<template>
    <div class="pages">

        <router-link :to="{ name: 'Home' }" tag="span" class="logo">
            <img src="../../../static/images/logo.png" alt="" class="logo-img">
        </router-link>

        <div class="box">
            <div class="box-tit">{{ $t('忘记密码') }}</div>
            <div class="box-box">
                <div class="box-ipt">
                    <div class="ipt-tit">{{ $t('手机号') }}</div>
                    <div class="ipt-ipt">
                        <el-dropdown @command="prefixHandleCommand">
                            <span class="el-dropdown-link">
                                +{{ prefix }}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="item.name" v-for="(item, index) in prefix_list"
                                    :key="index">
                                    {{ item.name }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <input type="number" :placeholder="$t('请输入您的手机号')" v-model="mobile">
                    </div>
                </div>
                <div class="box-ipt">
                    <div class="ipt-tit">{{ $t('验证码') }}</div>
                    <div class="ipt-ipt">
                        <input type="text" :placeholder="$t('请输入右侧验证码')" v-model="right_code" maxlength="4">
                        <Picture-verification @freshCode="refreshCode" slot="append" :identifyCode="identifyCode"
                            :contentWidth="120" :contentHeight="40" style="cursor: pointer;"></Picture-verification>
                    </div>
                </div>
                <div class="box-ipt">
                    <div class="ipt-tit">{{ $t('验证码') }}</div>
                    <div class="ipt-ipt">
                        <input type="number" :placeholder="$t('请输入您的验证码')" class="ipt-ipt-left" v-model="code">
                        <captcha-fetch @onCode="onPhoneCode" ref="phoneCode"></captcha-fetch>
                    </div>
                </div>
                <div class="box-ipt">
                    <div class="ipt-tit">{{ $t('密码') }}</div>
                    <div class="ipt-ipt">
                        <input :type="input_type" :placeholder="$t('请输入新密码(6~12位字母+数字)')" v-model="password">
                        <img src="../../../static/images/icon/icon03.png" alt="" v-if="input_type == 'password'"
                            @click="input_type = 'text'">
                        <img src="../../../static/images/icon/icon02.png" alt="" v-else
                            @click="input_type = 'password'">
                    </div>
                </div>
                <div class="box-btn pointer" @click="onConfirm">{{ $t('确定') }}</div>
                <div class="justify-center text-14 margin-top-32">
                    <router-link :to="{ name: 'Login' }" class="right-txt">
                        {{ $t('已有账号，前去') }} <span class="text-61AC85">{{ $t('登录') }}</span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FixedBar from '@/components/FixedBar'
import AppFooter from '@/components/AppFooter'
import CaptchaFetch from '@/components/CaptchaFetch'
import PictureVerification from '@/components/PictureVerification'
import { formerAmendPassword, mobileAmendPassword, getCode } from '@/api/login';
import { phonePrefix,getconf } from '@/api/user';

export default {
    name: 'changePassword',
    components: {
        'fixed-bar': FixedBar,
        'app-footer': AppFooter,
        'captcha-fetch': CaptchaFetch,
        'Picture-verification': PictureVerification
    },
    data() {
        return {
            input_type: 'password',//输入框type
            identifyCode: '',//图形四位验证码
            right_code: '',//四位图形验证码
            mobile: '18530416250',//手机号
            code: '',//验证码
            password: '',//新密码
            prefix_list: [],//前缀列表
            prefix: '',//前缀
			app_logo: '',//logo
        }
    },
    mounted() {
        const chars = '0123456789abcdefghijklmnopqrstuvwxyz';
        let result = '';
        for (let i = 0; i < 4; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        this.identifyCode = result
        this.onPhonePrefix();
		this.onGetconf()
    },
    methods: {
        onGetconf() {
			getconf({ module: 'app' }).then(res => {
				if (res.code == 1) {
					let data = res.data
					this.app_logo = data.app_logo
				}
			})
		},
        /**前缀切换 */
        prefixHandleCommand(e) {
            // console.log(e);
            this.prefix = e
        },
        /**手机号前缀 */
        onPhonePrefix() {
            phonePrefix().then(res => {
                this.prefix_list = res.data
                this.prefix = this.prefix_list[0].name
                console.log(res.data);
            })
        },
        /**确定 */
        onConfirm() {
            if (!this.mobile) {
                this.$message.warning(this.$t('请输入手机号'));
                return
            }
            if (!this.right_code) {
                this.$message.warning(this.$t('请输入四位图形码'));
                return
            }
            if (this.identifyCode != this.right_code) {
                this.refreshCode()
                this.right_code = ''
                this.$message.warning(this.$t('图形码错误，请重新输入'));
                return
            }
            if (!this.code) {
                this.$message.warning(this.$t('请输入验证码'));
                return
            }
            if (!this.password) {
                this.$message.warning(this.$t('请输入新密码'));
                return
            }

            let data = {
                mobile: this.mobile,
                code: this.code,
                type: 2,
                password: this.password,
				prefix: this.prefix,
            }

            mobileAmendPassword(data).then(res => {
                if (res.code == 1) {
                    this.$message.success(this.$t('修改成功，前去登录'));
                    this.mobile = ''
                    this.right_code = ''
                    this.code = ''
                    this.password = ''
                } else {
                    this.$message.warning(res.msg);
                }
            })
        },
        //重置验证码
        refreshCode() {
            const chars = '0123456789abcdefghijklmnopqrstuvwxyz';
            let result = '';
            for (let i = 0; i < 4; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            this.identifyCode = result
        },
        /**获取手机验证码 */
        onPhoneCode() {
            if (!this.mobile) {
                this.$message.warning(this.$t('请输入手机号'));
                return
            }
            // this.$refs.phoneCode.start()
            // return
            let data = {
                mobile: this.mobile,
                type: 2,
                is_test: this.$isDev,
				prefix: this.prefix,
            }
            getCode(data).then(res => {
                if (res.code == 1) {
                    if (this.$isDev == 1) {
                        this.$message.success(this.$t('验证码为：') + res.data.code);
                        this.code = res.data.code
                    } else {
                        this.$message.error(res.data.msg);
                    }
                    this.$refs.phoneCode.start()
                } else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        //区域选择
        handleCommand(command) {
            // this.$message('click on item ' + command);
            console.log(command);
        }
    }
};
</script>

<style scoped lang="scss">
.pages {
    padding-top: 24px;
	min-height: 100vh;
	height: auto;
	background: url('../../../static/images/bg/bg01.png') no-repeat;
	background-size: cover;
	background-position: center;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-left: 16px;
	padding-right: 16px;
}

.logo {
    display: flex;
    justify-content: center;
    padding-bottom: 60px;

    .logo-img {
        width: 160px;
        height: 85px;
        cursor: pointer;
    }
}

.box {
    display: flex;
	flex-direction: column;
	align-items: center;
	background: #FFFFFF;
	box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
	border-radius: 8px;
	padding: 24px 20px;
	width: 100%;
	max-width: 780px;

	@media (min-width: 768px) {
		padding: 32px 100px;
	}

    .box-tit {
        font-size: 36px;
        color: #333333;
        font-weight: 500;
        margin-bottom: 16px;
    }

    .box-box {
        width: 100%;
        max-width: 580px;

        /**输入框 */
        .box-ipt {
            width: 100%;
            border-bottom: 1px solid #666666;
            margin-top: 24px;

            .ipt-tit {
                font-size: 16px;
            }

            .ipt-ipt {
                padding: 16px 0;
                display: flex;
                align-items: center;
                justify-content: space-between;

                input {
                    font-size: 16px;
                    width: calc(100% - 50px);
                }

                img {
                    width: 24px;
                    height: 24px;
                    cursor: pointer;
                }

                .ipt-ipt-left {
                    width: calc(100% - 150px);
                }
            }
        }

        /**按钮 */
        .box-btn {
            width: 100%;
            height: 56px;
            margin-top: 48px;
            background: #FFFFFF;
            border-radius: 4px;
            border: 1px solid #000000;
            font-size: 20px;
            color: #000000;
            line-height: 56px;
            text-align: center;
        }

        /**用户协议或隐私政策 */
        .box-read {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: #333333;
            margin-top: 12px;
            cursor: pointer;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/login/changePassword.vue